import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Typography, Button } from "@mui/material";

const Pending = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Typography variant="h5" gutterBottom align="center">
        Pago en Proceso
      </Typography>
      <Typography variant="body1" gutterBottom align="center">
        Tu pago está siendo procesado. Te notificaremos cuando se haya
        completado.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/home")}
        fullWidth
      >
        Volver al Inicio
      </Button>
    </Container>
  );
};

export default Pending;
